import { gql } from '@apollo/client';
import { Box } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { CellProps } from 'react-table';
import { ConfigurationTable_ConfigurationFragment } from '../__generated__/ConfigurationsTable.graphql';

export function DescriptionCell({
  value,
}: PropsWithChildren<CellProps<ConfigurationTable_ConfigurationFragment, string>>) {
  return (
    <Box
      sx={{
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
      fontWeight="semibold"
    >
      {value}
    </Box>
  );
}

DescriptionCell.graphql = {
  fragments: {
    DescriptionCell_powerSchedule: gql`
      fragment DescriptionCell_configuration on ConfigurationModel {
        id
        description
      }
    `,
  },
};
